import React, { createContext, useContext, useReducer } from 'react'

export const SecondaryNavContext = createContext()
export const SecondaryNavContextProvider = ({reducer, initialState = { secondaryNav: false }, children}) => (
  <SecondaryNavContext.Provider value={useReducer(reducer, initialState)}>
    { children }
  </SecondaryNavContext.Provider>
)
export const useSecondaryNavState = () => useContext(SecondaryNavContext)


// WEBPACK FOOTER //
// ./src/reducers/nav/provider.js